type FilterItem = Record<string, string | number | boolean> | false | null | undefined;

const formQueryUrl = (filters: FilterItem[]) => {
  const params = filters
    .filter((item): item is Record<string, string | number | boolean> => !!item)
    .map((item) => {
      const key = Object.keys(item)[0];
      return `${key}=${encodeURIComponent(String(item[key]))}`;
    });

  return params.length ? `&${params.join("&")}` : "";
};

export default formQueryUrl;
